var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_1829",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#94c83d}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    d: "M26.437 28.031a.643.643 0 0 0-.816.4 5.361 5.361 0 0 1-5.175 3.42 5.361 5.361 0 0 1-5.143-3.42.644.644 0 0 0-1.221.411 6.75 6.75 0 0 0 6.364 4.294 6.75 6.75 0 0 0 6.429-4.294.643.643 0 0 0-.437-.816z",
    className: "cls-1",
    transform: "translate(-6.945 -11.927)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    d: "M16.5 3A13.5 13.5 0 1 0 30 16.5 13.5 13.5 0 0 0 16.5 3zm0 25.714A12.214 12.214 0 1 1 28.715 16.5 12.214 12.214 0 0 1 16.5 28.714z",
    className: "cls-1",
    transform: "translate(-3 -3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    d: "M14.893 16.286c.887 0 1.607 1.054 1.607 1.929a.643.643 0 0 0 1.286 0A3.2 3.2 0 0 0 14.893 15 3.2 3.2 0 0 0 12 18.214a.643.643 0 0 0 1.286 0c0-.874.72-1.928 1.607-1.928z",
    className: "cls-1",
    transform: "translate(-6.214 -7.286)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    d: "M29.893 15A3.2 3.2 0 0 0 27 18.214a.643.643 0 0 0 1.286 0c0-.874.72-1.929 1.607-1.929S31.5 17.34 31.5 18.214a.643.643 0 0 0 1.286 0A3.2 3.2 0 0 0 29.893 15z",
    className: "cls-1",
    transform: "translate(-11.571 -7.286)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileySelected);
export default __webpack_public_path__ + "static/media/smiley-selected.5c06c66a5b1295ac6af6d30ba0f7a340.svg";
export { ForwardRef as ReactComponent };